export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・La información a rellenar en el plan de mejora se muestra en {toCompanyName}.\n・Los adjuntos se muestran en {toCompanyName}, y solo se mostrará el nombre del archivo.',
    },
    chat: {
      card_title: 'Mensaje',
      input_area_description: 'Puede enviar un mensaje a {toCompanyName} con respecto al plan de mejora',
      send_confirm: {
        modal_title: 'Compruebe el mensaje que se enviará.',
        confirm_text: '¿Seguro que desea enviar este mensaje?',
        confirm_text_near_by_check_box: 'Mensaje verificado',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: 'Eliminar este mensaje',
        confirm_text: '¿Seguro que desea eliminar este mensaje?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: 'Enviar historia',
        send_status: {
          success: 'Enviado',
          failure: 'No se ha podido enviar',
        },
      },
    },
  },
}
